import _ from 'lodash'

export const arrayToSentence = (arr, separator = ', ', lastSeparator = ' and ') => {
  if (!arr) {
    return ''
  }

  if (arr.length === 0) {
    return ''
  }

  if (arr.length === 1) {
    return arr[0]
  }

  return arr.slice(0, -1).join(separator) + lastSeparator + arr[arr.length - 1]
}

export const userStatusFormatter = (status = '', user = {}) => {
  if (status === 'active' && user.isDeactivationPending) {
    return 'Pending Deactivation'
  }

  if (status === 'email_sent') {
    return 'Pending Activation'
  }

  if (status === 'accessible_termination' && user.secondaryEmail) {
    return `Email Access`
  }

  if (status === 'accessible_termination') {
    return 'Email Access'
  }

  return _.capitalize(status)
}

export const parseErrorMessage = (errResponse) => {
  let errorMessage = _.get(errResponse, 'response.data.data', 'Server Error. Please try again in a few moments.')
  if (typeof errorMessage === 'object') {
    errorMessage = _.values(errorMessage)[0]
  }

  return errorMessage
}
